import axios from 'axios';
import { settings } from '../config';
const tg = window?.Telegram?.WebApp;
const initData = tg?.initData;

export async function getMessage() {
  const encodedInitData = encodeURIComponent(initData || '');
  const config = {
    headers: {
      Authorization: `Bearer ${encodedInitData}`,
    },
  };
  try {
    const url = `${settings.url}users/messages/forward`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
